import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Button, Icon } from 'semantic-ui-react';
import Header from 'components/Header';
import InlineEditIconButton from 'components/InlineEditIconButton';
import API from 'utils/api';
import formatter from 'utils/formatter';
import Message from 'components/Message';
import CancelGoButtons from 'components/CancelGoButtons';
import BackLink from 'components/BackLink';

class MenuProductPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      productId: null,
      product: null,
      productIngredients: [],
      showArchiveAlert: false,
      showDangerZone: false,
      loading: true
    };
  }
  
  componentDidMount() {
    const productId = parseInt(this.props.match.params.productId);
    this.setState({ productId }, this.getProduct);
  }

  getProduct = () => {
    const { productId } = this.state;
    Promise.all([
      API.getProduct(productId),
      API.getProductIngredients(productId)
    ])
      .then(([productRes, ingredientsRes]) => {
        this.setState({
          product: productRes.data,
          productIngredients: ingredientsRes.data,
          loading: false
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: false });
      });
  }

  // Disable for now
  // toggleProductAvailability = () => {
  //   API.toggleMicroProductAvailability(this.state.productId)
  //     .then((response) => {
  //       this.getProduct();
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // }
  // 
  // <div style={{ marginBottom: '1.5em', display: 'flex', justifyContent: 'space-between' }}>
  //   { this.state.product.out_of_stock ? (
  //     <Label color="red" style={{ marginRight: '0.5em' }}>
  //       no disponible
  //     </Label>
  //   ) : (
  //     <Label color="green" style={{ marginRight: '0.5em' }}>
  //       disponible
  //     </Label>
  //   )}

  //   <Button icon circular onClick={this.toggleProductAvailability} size="mini">
  //     { this.state.product.out_of_stock ? (
  //       <Icon name="check" />
  //     ) : (
  //       <Icon name="close" />
  //     )}
  //   </Button>
  // </div>
  // 
  
  showArchiveAlert = () => {
    this.setState({showArchiveAlert: true})
  }

  hideArchiveAlert = () => {
    this.setState({showArchiveAlert: false})
  }

  archiveProduct = () => {
    API.archiveMicroProduct(this.state.productId)
      .then((response) => {
        // redirect to products page
        this.props.history.push('/menu/products');
      })
      .catch((error) => {
        console.log(error);
      });
  }

  handleAddCost = () => {
    // Navigate to the product cost form
    this.props.history.push(`/menu/products/${this.state.productId}/cost`);
  }
  
  handleAddDescription = () => {
    // Navigate to the product description form
    this.props.history.push(`/menu/products/${this.state.productId}/description`);
  }

  handleIngredients = () => {
    this.props.history.push(`/menu/products/${this.state.productId}/ingredients`);
  }

  render() {
    if (this.state.loading) {
      return (
        <div style={{ textAlign: 'center', padding: '2em' }}>
          <Icon loading name='spinner' size='large' />
          <p style={{ marginTop: '1em', color: '#666' }}>Cargando producto...</p>
        </div>
      );
    }
    
    if (!this.state.product) { 
      return (
        <div style={{ padding: '1.5em' }}>
          <Message>
            <p style={{ fontSize: '1.1em', textAlign: 'center' }}>
              No se encontró el producto.
            </p>
            <div style={{ textAlign: 'center', marginTop: '1.5em' }}>
              <Button 
                as={Link} 
                to="/menu/products"
                style={{
                  height: '54px',
                  fontSize: '1.1em',
                  borderRadius: '8px',
                  boxShadow: 'none'
                }}
              >
                Regresar al menú
              </Button>
            </div>
          </Message>
        </div>
      ); 
    }
    
    // Display archive confirmation
    if (this.state.showArchiveAlert) {
      return (
        <div style={{ marginTop: '1em' }}>
          <Message>
            <p style={{ textAlign: 'center', fontSize: '1.2em', marginBottom: '1.5em' }}>
              ¿Estás seguro de archivar este producto?
            </p>

            <p style={{ textAlign: 'center', fontSize: '1.4em', fontWeight: 'bold', marginBottom: '1.5em' }}>
              {this.state.product.name}
            </p>
            
            <p style={{ textAlign: 'center', fontSize: '1.1em', marginBottom: '1.5em', color: '#666' }}>
              Si archivas este producto ya no podrás volver a usarlo.
            </p>
  
            <CancelGoButtons
              cancelFn={this.hideArchiveAlert}
              cancelText="cancelar"
              goText="archivar"
              goEnabled={true}
              goFn={this.archiveProduct}
              warning={true}
              style={{
                button: {
                  height: '54px',
                  fontSize: '1.1em',
                  fontWeight: 'bold',
                  boxShadow: 'none',
                  borderRadius: '8px'
                }
              }}
            />
          </Message>
        </div>
      );
    }
    
    // Normal product display
    return (
      <div>
        <BackLink onClick={() => this.props.history.push('/menu/products')} />

        <Header text={this.state.product.name} subtitle={this.state.product.product_category.name} />
        
        {/* Description section */}
        <div style={{
          marginBottom: '1.5em'
        }}>
          {this.state.product.desc ? (
            <>
              <div style={{ marginBottom: '8px' }}>
                <div style={{
                  fontSize: '1.5em',
                  color: '#777'
                }}>
                  Descripción
                </div>
              </div>
              <div style={{
                fontSize: '1.3em',
                fontWeight: 'normal',
                color: 'inherit',
                lineHeight: '1.4',
                marginTop: '5px'
              }}>
                {this.state.product.desc}
              </div>
            </>
          ) : (
            <Button
              onClick={this.handleAddDescription}
              primary
              fluid
              style={{
                height: '54px',
                fontSize: '1.1em',
                fontWeight: 'bold',
                boxShadow: 'none',
                borderRadius: '8px'
              }}
            >
              agregar descripción
            </Button>
          )}
        </div>

        {/* Ingredients section */}
        <div style={{ marginBottom: '1.5em' }}>
          {this.state.productIngredients.length > 0 ? (
            <>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                <div style={{ fontSize: '1.5em', color: '#777' }}>
                  Ingredientes
                </div>
                <InlineEditIconButton
                  ariaLabel="Editar ingredientes"
                  onClick={this.handleIngredients}
                />
              </div>
              <div style={{ fontSize: '1.2em', color: '#555', lineHeight: '1.4' }}>
                {this.state.productIngredients.map(pi => pi.ingredient.name).join(', ')}
              </div>
            </>
          ) : (
            <Button
              onClick={this.handleIngredients}
              primary
              fluid
              style={{
                height: '54px',
                fontSize: '1.1em',
                fontWeight: 'bold',
                boxShadow: 'none',
                borderRadius: '8px'
              }}
            >
              agregar ingredientes
            </Button>
          )}
        </div>

        {/* Price section */}
        <div style={{
          marginBottom: '1.5em'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <div style={{
              fontSize: '1.5em',
              color: '#777'
            }}>
              Precio
            </div>
            <div style={{
              fontSize: '1.8em',
              fontWeight: 'normal',
              color: '#555',
              textAlign: 'right'
            }}>
              {formatter.currency(this.state.product.price)}
            </div>
          </div>
        </div>

        {/* Cost section */}
        <div style={{
          marginBottom: '1.5em'
        }}>
          {this.state.product.cost !== null && this.state.product.cost !== undefined ? (
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <div style={{
                fontSize: '1.5em',
                color: '#777'
              }}>
                Costo
              </div>
              <div style={{
                fontSize: '1.8em',
                fontWeight: 'normal',
                color: '#555',
                textAlign: 'right'
              }}>
                {formatter.currency(this.state.product.cost)}
              </div>
            </div>
          ) : (
            <Button
              onClick={this.handleAddCost}
              primary
              fluid
              style={{
                height: '54px',
                fontSize: '1.1em',
                fontWeight: 'bold',
                boxShadow: 'none',
                borderRadius: '8px'
              }}
            >
              agregar costo
            </Button>
          )}
        </div>
        
        {/* Profit section */}
        {this.state.product.cost !== null && this.state.product.cost !== undefined && (
          <div style={{ 
            marginBottom: '1.5em'
          }}>
            <div style={{ 
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <div style={{ 
                fontSize: '1.5em', 
                fontWeight: 'bold',
                color: '#555'
              }}>
                Ganancia
              </div>
              <div style={{ 
                fontSize: '1.8em', 
                fontWeight: 'bold', 
                color: '#555',
                textAlign: 'right'
              }}>
                {formatter.currency(this.state.product.price - this.state.product.cost)}
              </div>
            </div>
          </div>
        )}

        {/* Danger Zone */}
        <div style={{ marginTop: '3em' }}>
          <div
            onClick={() => this.setState({ showDangerZone: !this.state.showDangerZone })}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.4em',
              cursor: 'pointer',
              color: '#db2828',
              fontSize: '1em',
              userSelect: 'none'
            }}
          >
            <Icon name={this.state.showDangerZone ? 'chevron down' : 'chevron right'} />
            Zona de peligro
          </div>

          {this.state.showDangerZone && (
            <div style={{
              marginTop: '1em',
              padding: '1em',
              border: '1px solid #db2828',
              borderRadius: '8px'
            }}>
              <Button
                fluid
                basic
                color="red"
                onClick={this.showArchiveAlert}
                style={{ boxShadow: 'none', borderRadius: '8px' }}
              >
                Archivar producto
              </Button>
            </div>
          )}
        </div>

      </div>
    )
  }
}

export default withRouter(MenuProductPage);